import React, { useRef, useState, useEffect, useCallback } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import GenerateQuestion from "./GenerateQuestion";
import { useNavigate, useParams } from "react-router-dom";
import { Routes } from "../../constants";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import { injectModels } from "../../redux/injectModels";
import { useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const LiveSession = (props) => {
  let requestId;
  const reconnectInterval = useRef(1000);
  const location = useLocation();
  const navigate = useNavigate();
  const { session_id } = useParams();
  const { userId } = location.state || {};
  const videoRef = useRef();
  const transcriptRef = useRef();
  const mikeTranscriptRef = useRef();
  const [show, setShow] = useState(false);
  const [micData, setMicData] = useState("");
  const [timestamp, setTimestamp] = useState();
  const [socket, setSocket] = useState(null);
  const [isDetectingSilence, setIsDetectingSilence] = useState(true);
  const [isTranscript, setIsTranscript] = useState("");
  const [miketranscript, setMikeTranscript] = useState("");
  const [activeButton, setActiveButton] = useState(null);
  const [disable, setDisable] = useState(false);
  const [completeActiveButton, setCompleteActiveButton] = useState(false);
  const [mediarecording, setMediarecording] = useState(null);
  const [recognitionInstance, setRecognitionInstance] = useState(null);
  const activeButtonRef = useRef(activeButton);


 
  useEffect(() => {
    activeButtonRef.current = activeButton;
    if (activeButton !== null) {
      sendData();
    }
  }, [activeButton]);

  useEffect(() => {
    handleShow();
    connectSocket();
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, []);

  const connectSocket = async () => {
    const ws = new WebSocket(
      `${process.env.REACT_APP_API_WEBSOCKET}/transcript/ws/${session_id}`
    );
    
    
    
    

    const openPromise = new Promise((resolve, reject) => {
      ws.onopen = (event) => {
        setSocket(ws);

        resolve();
      };
      ws.onmessage = (event) => {
        try {

          setIsTranscript((prev) => `${prev} ${event.data}`);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        reject(error);
      };
    });

    const closePromise = new Promise((resolve) => {
      ws.onclose = (event) => {
        if (!event.wasClean || event.code === 1006) {
          setTimeout(connectSocket, reconnectInterval.current);
          reconnectInterval.current = Math.min(
            reconnectInterval.current * 2,
            30000
          ); // Cap at 30 seconds
        }

        setSocket(null);
        resolve();
      };
    });

    try {
      await openPromise;
      console.log("WebSocket connection established and ready for messages.");
    } catch (error) {
      console.error("Failed to open WebSocket connection:", error);
    }

    await closePromise;
    console.log("WebSocket connection closed.");
  };

  useEffect(() => {
    if (transcriptRef.current) {
      transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
    }
    if (mikeTranscriptRef.current) {
      mikeTranscriptRef.current.scrollTop =
        mikeTranscriptRef.current.scrollHeight;
    }
    mike();
  }, [isTranscript, miketranscript]);

  const transcriptLines = isTranscript.split("\n");
  const filteredTranscriptLines = transcriptLines.reduce(
    (acc, line, index, array) => {
      if (line.trim() !== "") {
        acc.push(line); // Add non-empty lines
      } else if (index === array.length - 1) {
        acc.push(""); // Ensure at least one empty string at the end
      }
      return acc;
    },
    []
  );

  // If the result is empty, add a single empty string
  if (filteredTranscriptLines.length === 0) {
    filteredTranscriptLines.push("");
  }
  const transcriptElements = filteredTranscriptLines.map((line, index) => (
    <div key={index} className="message stark user1 user2">
      {line ? (
        <p>{line}</p>
      ) : (
        <ThreeDots
          visible={true}
          height="30"
          width="30"
          color="#ee8e87"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      )}
    </div>
  ));

  const handleButtonClick = (buttonName) => {
    if (mediarecording && mediarecording.state === "recording") {
      mediarecording.stop();
      setTimeout(() => {
        if (mediarecording.state !== "recording") {
          mediarecording.start();
        }
      }, 10);
    }
    // console.log("Bookmark button clicked. Audio chunks sent.");
    setActiveButton(buttonName);
    setDisable(true);
  };

  const handleResetBookmarks = () => {
    if (mediarecording && mediarecording.state === "recording") {
      mediarecording.stop();
      setTimeout(() => {
        if (mediarecording.state !== "recording") {
          mediarecording.start();
        }
      }, 10);
    }
    setActiveButton(null);
    setDisable(false);
    setCompleteActiveButton(false);
  };

  const sendData = async () => {
    try {
      // Call the API only if micData is not empty
      if (!micData.trim()) {
        console.log("Mic data is empty, API call skipped.");
        return; // Skip API call if micData is empty
      }

      const data = {
        session_id: session_id,
        data: micData,
        timestamp: timestamp,
        type: activeButtonRef.current ? `<${activeButtonRef.current}>` : "",
      };
      // console.log("Mic data:", data);

      const response = await props.admin.micData(data, session_id);

      // setMicData("");
      // setTimestamp();
      
    } catch (error) {
      console.error("Error occurred while sending data:", error);
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return <div>Speech recognition not supported</div>;
  }

  const sendAudioChunks = (recordedChunks) => {
    if (recordedChunks.length === 0) {
      return;
    }
    const blob = new Blob(recordedChunks, { type: "audio/mp4" });
    if (blob.size >= 100 && blob.size <= 5000) {
      console.log(
        "Blob size is 105,5000 bytes, saving locally for verification."
      );

      // Save the blob locally
      // const downloadLink = document.createElement("a");
      // const url = URL.createObjectURL(blob);
      // downloadLink.href = url;
      // downloadLink.download = `audio_${blob.size}bytes_${Date.now()}.mp4`; // Unique filename
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
      // document.body.removeChild(downloadLink);
      // URL.revokeObjectURL(url); // Clean up the URL object
      //
      return;
    }
    if (blob.size >= 5000 && blob.size <= 10000) {
      console.log("Blob size is between 5000 and 10000 bytes");
      // const audioURL = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = audioURL;
      // a.download = `audio_${blob.size}bytes_${Date.now()}.mp4`;
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      // URL.revokeObjectURL(audioURL);
      return;
    }
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const data = JSON.stringify({
      session_id: session_id,
      timestamp: currentTimestamp,
      type: activeButtonRef.current ? `<${activeButtonRef.current}>` : "",
    });

    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(blob);
      // console.log("Audio data sent:", blob);
      socket.send(data);
      // console.log("Metadata sent:", data);
    } else {
      console.error("WebSocket connection is not open.");
    }
  };

  const mike = async () => {
    if (window.recognitionInstance) {
      window.recognitionInstance.stop();
    }

    const recognition = new (window.SpeechRecognition ||
      window.webkitSpeechRecognition)();
    recognition.continuous = true;
    recognition.interimResults = false;
    recognition.lang = "hi-IN";

    recognition.onresult = async (event) => {
      try {
        for (let i = event.resultIndex; i < event.results.length; i++) {
          if (event.results[i].isFinal) {
            const currentTime = Math.floor(Date.now() / 1000);
            // console.log("mike result", event.results[i][0].transcript);
            try {
              const mikeData =
                event.results[i][0].transcript &&
                event.results[i][0].transcript + ".";
              await setMikeTranscript(
                (prevTranscript) => `${prevTranscript} ${mikeData}`
              );
            } catch (error) {
              console.error("Error updating transcript:", error.message);
            }
            setMicData(event.results[i][0].transcript);
            setTimestamp(currentTime);

            // mikeArray.push({
            //   data: event.results[i][0].transcript || " ",
            //   timestamp: currentTime,
            // });

            if (event.results[i][0].transcript?.trim()) {
              try {
                // Check if micData is not empty before calling sendData
                if (event.results[i][0].transcript.trim()) {
                  await sendData();
                }
              } catch (error) {
                console.error("Error sending data:", error.message);
                // mike();
              }
            }
          }
        }
      } catch (error) {
        console.error(
          "Error processing speech recognition result:",
          error.message
        );
        // mike();
      }
      // mike();
    };

    recognition.onerror = (event) => {
      if (event.error === "aborted") {
        console.log("Speech recognition aborted, restarting...");
        mike();
      } else {
        console.error("Speech recognition error:", event.error);
        mike();
      }
    };

    try {
      recognition.start();
      setRecognitionInstance(recognition);
      window.recognitionInstance = recognition;
    } catch (error) {
      console.error(
        "Error starting recognition or setting instance:",
        error.message
      );
      // mike();
    }
  };

  const miketranscriptLines = miketranscript.split(".");
  const miketranscriptElements = miketranscriptLines.map((line, index) => (
    <div className="message stark user1" key={index}>
      {line ? (
        <p>{line}</p>
      ) : (
        <ThreeDots
          visible={true}
          height="30"
          width="30"
          color="#5ad4c3"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      )}
    </div>
  ));

  const shareScreenAndRecord = async () => {
    let mediaRecorder;
    let recordedChunks = [];
    const silenceThreshold = -10; //-10 Threshold to detect silence
    const maxRecordingInterval = 20 * 1000; // 15 seconds in milliseconds
    let silenceTimeoutId; // To keep track of the timeout
    const audioContext = new window.AudioContext();

    try {
      // Get the display media stream with both video and audio
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
        audio: true,
      });
      // console.log("Display media stream obtained:", stream);
      videoRef.current.srcObject = stream;

      // Create a MediaStreamAudioDestinationNode
      const audioDestination = audioContext.createMediaStreamDestination();

      // Get the original audio track from the stream
      const audioTracks = stream.getAudioTracks();
      if (audioTracks.length > 0) {
        const originalAudioSource = audioContext.createMediaStreamSource(
          new MediaStream([audioTracks[0]])
        );
        originalAudioSource.connect(audioDestination);
      }

      // Create a new MediaStream with only the audio track
      const combinedStream = new MediaStream([
        ...audioDestination.stream.getAudioTracks(),
      ]);

      const startRecording = () => {
        if (!combinedStream) {
          console.error("No media stream available to record.");
          return;
        }

        mediaRecorder = new MediaRecorder(combinedStream);
        setMediarecording(mediaRecorder);

        mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            recordedChunks.push(event.data);
            // console.log("Data available:", event.data);
          }
        };

        mediaRecorder.onstop = () => {
          if (mediaRecorder.state === "inactive") {
            try {
              sendAudioChunks(recordedChunks);
              recordedChunks = [];
              resetSilenceTimeout(); // Reset the silence timeout after sending chunks
              startRecording(); // Restart the recording after stopping
            } catch (error) {
              console.error("Error processing audio chunks:", error);
            }
          }
        };

        mediaRecorder.start(500);
        resetSilenceTimeout(); // Start the silence timeout when recording starts
      };

      const analyser = new AnalyserNode(audioContext, { fftSize: 256 });
      const source = audioContext.createMediaStreamSource(
        audioDestination.stream
      );
      source.connect(analyser);

      const dataArray = new Uint8Array(analyser.frequencyBinCount);

      const detectSilence = () => {
        analyser.getByteFrequencyData(dataArray);
        const maxVolume = Math.max(...dataArray);
        const decibel = 20 * Math.log10(maxVolume / 255);

        if (decibel < silenceThreshold) {
          if (mediaRecorder.state === "recording") {
            // console.log("Silence detected, stopping recording.");
            mediaRecorder.stop();
          }
        }

        requestAnimationFrame(detectSilence);
      };

      const resetSilenceTimeout = () => {
        clearTimeout(silenceTimeoutId);
        silenceTimeoutId = setTimeout(() => {
          if (mediaRecorder.state === "recording") {
            // console.log("Max recording interval reached, stopping recording.");
            mediaRecorder.stop();
          }
        }, maxRecordingInterval);
      };

      handleClose(); // Custom function, ensure it is defined or remove it if unnecessary
      startRecording();
      detectSilence();
    } catch (error) {
      console.error("Error accessing display media:", error);
    }
  };

  // const stopRecordingAndSharing = async () => {
    // try {
      // const data={
        // session_id:session_id
      // }
      // const response = await props.admin.allMarkedQuestion(data);
      // if (response.success) {
        // if(response.all_relevant === true){
          // props.application.setLoading(true);
          // 10-second delay
          // await new Promise((resolve) => setTimeout(resolve, 10000));
          // const currentTime = Math.floor(Date.now() / 1000);
          // const data = {
            // end_time: currentTime,
          // };
          // const response = await props.admin.CompleteSession(session_id, data);
          // if (response.success === true) {
            // const stream = videoRef.current.srcObject;
            // if (stream) {
              // const tracks = stream.getTracks();
              // tracks.forEach((track) => track.stop());
            // }
            // if (mediarecording && mediarecording.state === "recording") {
              // mediarecording.stop();
              // setMediarecording(null);
            // }
            // if (recognitionInstance) {
              // recognitionInstance.stop();
              // setRecognitionInstance(null);
              // window.recognitionInstance = null;
              // console.log("Speech recognition stopped.");
            // }
            // if (socket) {
              // socket.close();
              // setSocket(null);
            // } else {
              // console.log("WebSocket is already closed or not connected.");
            // }
            // setIsDetectingSilence(false);
            // setActiveButton(null);
            // cancelAnimationFrame(requestId);
            // toast.dismiss();
            // toast.success(response.message, {
              // position: toast.POSITION.TOP_CENTER,
            // });
            // navigate(Routes.SESSION);
          // } else {
            // toast.dismiss();
            // toast.error(response.message, {
              // position: toast.POSITION.TOP_CENTER,
            // });
          // }
        //  
        // }else{
          // toast.error(response.message,{position: toast.POSITION.TOP_CENTER,});
        // }
      // } else {
        // console.error("Failed to fetch session data");
      // }
    // } catch (error) {
      // console.log(error);
      // toast.dismiss();
      // toast.error("Something went wrong!", {
        // position: toast.POSITION.TOP_CENTER,
      // });
    // } finally {
      // props.application.setLoading(false);
    // }
  // };


  const handleBack = () => {
    if (socket) {
      socket.close();
      setSocket(null);
    } else {
      console.log("WebSocket is already closed or not connected.");
    }

    const stream = videoRef.current.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
    }
    if (mediarecording && mediarecording.state === "recording") {
      mediarecording.stop();
      setMediarecording(null);
    }
    if (recognitionInstance) {
      recognitionInstance.stop();
      setRecognitionInstance(null);
      window.recognitionInstance = null;
      console.log("Speech recognition stopped.");
    }
    navigate(Routes.SESSION);
  };

  const stopRecordingAndSharing = async () => {
    try {
          props.application.setLoading(true);
          // 10-second delay
          await new Promise((resolve) => setTimeout(resolve, 10000));
          const currentTime = Math.floor(Date.now() / 1000);
          const data = {
            end_time: currentTime,
          };
          const response = await props.admin.CompleteSession(session_id, data);
          if (response.success === true) {
            const stream = videoRef.current.srcObject;
            if (stream) {
              const tracks = stream.getTracks();
              tracks.forEach((track) => track.stop());
            }
            if (mediarecording && mediarecording.state === "recording") {
              mediarecording.stop();
              setMediarecording(null);
            }
            if (recognitionInstance) {
              recognitionInstance.stop();
              setRecognitionInstance(null);
              window.recognitionInstance = null;
              console.log("Speech recognition stopped.");
            }
            if (socket) {
              socket.close();
              setSocket(null);
            } else {
              console.log("WebSocket is already closed or not connected.");
            }
            setIsDetectingSilence(false);
            setActiveButton(null);
            cancelAnimationFrame(requestId);
            toast.dismiss();
            toast.success(response.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            navigate(Routes.SESSION);
          } else {
            toast.dismiss();
            toast.error(response.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        
       
    } catch (error) {
      console.log(error);
      toast.dismiss();
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      props.application.setLoading(false);
    }
  };
  // const handleMarkedQuestion =async() =>{
    // try {
      // const data={
        // session_id:session_id
      // }
      // const response = await props.admin.allMarkedQuestion(data);
      // if (response.success) {
        // if(response.all_relevant === true){
          // handleBack()    
        // }else{
          // toast.error(response.message,{position: toast.POSITION.TOP_CENTER,});
        // }
      // } else {
        // console.error("Failed to fetch session data");
      // }
    // } catch (error) {
      // console.error("Error occurred while sending data:", error);
    // }
  // }

  return (
    <>
      <div>
        <main id="main" className="main">
          <div className="pagetitle mb-3">
            <h1>Live Session</h1>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0)">Home</a>
                </li>
                <li className="breadcrumb-item active">Live Session</li>
              </ol>
            </nav>
          </div>
          <section>
            <div className="row g-2">
              <div className="col-12 ls-btns mb-2">
                <div className="all-bookmark-buttom">
                  <button
                    className={`btn btn-warning  btn-sm ${
                      activeButton === "email" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("email");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "email" ? "" : disable}
                  >
                    Email
                  </button>
                  <button
                    className={`btn btn-warning  btn-sm ${
                      activeButton === "normaltext" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("normaltext");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "normaltext" ? "" : disable}
                  >
                    Normal text
                  </button>
                  <button
                    className={`btn btn-warning  btn-sm ${
                      activeButton === "softwarestep" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("softwarestep");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "softwarestep" ? "" : disable}
                  >
                    Software steps
                  </button>
                  <button
                  className={`btn btn-warning  btn-sm ${
                    activeButton === "googlesheet" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleButtonClick("googlesheet");
                    setCompleteActiveButton(true);
                  }}
                  disabled={activeButton === "googlesheet" ? "" : disable}
                >
                  Excel google sheet
                </button>
                <button
                className={`btn btn-warning  btn-sm ${
                  activeButton === "googleform" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("googleform");
                  setCompleteActiveButton(true);
                }}
                disabled={activeButton === "googleform" ? "" : disable}
              >
                Google form Table
              </button>
                  <button
                    className={`btn btn-warning  btn-sm ${
                      activeButton === "heading" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("heading");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "heading" ? "" : disable}
                  >
                   PDF / Image
                  </button>
                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "subheading" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("subheading");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "subheading" ? "" : disable}
                  >
                    Sub heading
                  </button>
                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "supersubheading" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("supersubheading");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "supersubheading" ? "" : disable}
                  >
                    Super sub heading
                  </button>
                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "supersupersubheading" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("supersupersubheading");
                      setCompleteActiveButton(true);
                    }}
                    disabled={
                      activeButton === "supersupersubheading" ? "" : disable
                    }
                  >
                    Super super sub heading
                  </button>
                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "whatsapp" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("whatsapp");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "whatsapp" ? "" : disable}
                  >
                    Whatsapp
                  </button>

                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "normaltable" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("normaltable");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "normaltable" ? "" : disable}
                  >
                    Normal table
                  </button>

                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "dialogic" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("dialogic");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "dialogic" ? "" : disable}
                  >
                    Dialogic
                  </button>

                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "faq" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("faq");
                      setCompleteActiveButton(true);
                    }}
                    disabled={activeButton === "faq" ? "" : disable}
                  >
                    FAQ
                  </button>

                  <button
                    className={`btn btn-primary btn-sm ${
                      activeButton === "googlesheetexplanation" ? "active" : ""
                    }`}
                    onClick={() => {
                      handleButtonClick("googlesheetexplanation");
                      setCompleteActiveButton(true);
                    }}
                    disabled={
                      activeButton === "googlesheetexplanation" ? "" : disable
                    }
                  >
                    Google sheet explanation table
                  </button>

                  {activeButton !== null ? (
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => {
                        handleResetBookmarks();
                      }}
                    >
                      Reset
                    </button>
                  ) : (
                    ""
                  )}
                </div>

                <button
                  className="btn btn-secondary btn-sm"
                  onClick={handleBack}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary btn-sm completesession"
                  // style={{ marginLeft: "100px", marginRight: "px" }}
                  onClick={stopRecordingAndSharing}
                  disabled={completeActiveButton}
                >
                  Complete session{" "}
                </button>
              </div>
              <div className="col-sm-3 h-100">
                <div className="card cstm-card">
                  <div className="card-body px-3">
                    <h5 className="card-title cstm-head">
                      <strong className=" small">Mic</strong>
                    </h5>
                    <div
                      ref={mikeTranscriptRef}
                      className="speaker-transcrption"
                    >
                      {miketranscriptElements}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 h-100">
                <div className="card cstm-card">
                  <div className="card-body px-3">
                    <h5 className="card-title cstm-head dark">
                      <strong className=" small">Questions</strong>
                    </h5>

                    <GenerateQuestion userId={userId} props={props} />
                  </div>
                </div>
              </div>
              <div className="col-sm-3 h-100">
                <div className="card cstm-card">
                  <div className="card-body px-3">
                    <h5 className="card-title cstm-head dorg">
                      <strong className=" small">Speaker</strong>
                    </h5>
                    <video
                      width={200}
                      height={200}
                      ref={videoRef}
                      style={{ display: "none" }}
                      autoPlay
                      controls
                      muted
                    />
                    <div ref={transcriptRef} className="speaker-transcrption">
                      {transcriptElements}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Modal
          show={show}
          size="md"
          backdrop="static"
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title>Please share your screen</Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleBack}>
              Back
            </Button>
            <Button variant="primary" onClick={shareScreenAndRecord}>
              share Screen
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default injectModels(["admin", "application"])(LiveSession);
